import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withLocale } from 'core/hocs';
import { wrapRoute2Locale } from 'core/helpers';
import { TopBarContext } from 'hocs/with-top-bar';
import { IconBonus } from 'components/icons/icon-bonus/icon-bonus';

import './floating-bonus-button.scss';

class FloatingBonusButtonUI extends PureComponent {
  static propTypes = {
    history: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    isButtonHidden: PropTypes.bool,
  };

  static contextType = TopBarContext

  static defaultProps = {
    isButtonHidden: false,
  };

  onClick = () => {
    const { history, locale } = this.props;
    const { isRegistrationBonusOpen, showRegistrationBonus } = this.context;

    if (isRegistrationBonusOpen === null) {
      history.push(wrapRoute2Locale('/gifts', locale));
    } else if (isRegistrationBonusOpen === false) {
      showRegistrationBonus();
    }
  }

  render() {
    const { isButtonHidden } = this.props;

    if (isButtonHidden) {
      return null;
    }

    return (
      <div
        className="floating-bonus-button d-flex justify-content-center align-items-center position-fixed"
        role="button"
        tabIndex="0"
        onClick={this.onClick}
        onKeyPress={this.onClick}
      >
        <IconBonus />
      </div>
    );
  }
}

export const FloatingBonusButton = withRouter(withLocale(FloatingBonusButtonUI));
